//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Language',
  props: {
    lang: String
  },
  data: function data() {
    return {
      langList: {
        'zh-CN': '语言',
        // 'zh-TW': '語言',
        'en-US': 'Lang'
      },
      localList: {
        'zh-CN': '中文简体',
        // 'zh-TW': '中文繁体',
        'en-US': 'English'
      }
    };
  },
  watch: {
    lang: function lang(_lang) {
      this.$i18n.locale = _lang;
    }
  },
  computed: {
    title: function title() {
      return this.langList[this.lang];
    }
  },
  methods: {
    selectLang: function selectLang(name) {
      this.$emit('on-lang-change', name); //重新刷新数据

      location.reload();
    }
  }
};